import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form__control" };
const _hoisted_2 = ["onUpdate:modelValue", "disabled", "value", "required", "autocomplete", "id"];
const _hoisted_3 = ["disabled", "value", "required", "autocomplete", "id"];
import { ref, watch, computed } from 'vue';
import log from "../../services/Logger";
import { autocompleteAttr } from "./FormUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlChoiceExpanded',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = ref(null);
        const fieldOptions = ref(props.field.options || {});
        const autocomplete = computed(() => {
            return autocompleteAttr(fieldOptions.value);
        });
        model.value = fieldOptions.value.multiple ? {} : null;
        initModel();
        watch(() => props.data, initModel);
        function initModel() {
            if (fieldOptions.value.multiple) {
                const data = props.data || [];
                // for some unknown reason, the entire browser tab freezes
                // if we do this:
                // model.value = {};
                Object.getOwnPropertyNames(model.value)
                    .filter(prop => prop !== '__ob__')
                    .forEach(prop => model.value[prop] = false);
                if (Array.isArray(data)) {
                    // ['foo', 'bar'] => {foo: true, bar: true}
                    data.forEach((elem) => {
                        model.value[elem] = true;
                    });
                }
                else {
                    throw 'expected `data` to be an array';
                }
            }
            else {
                model.value = props.data;
            }
        }
        function onChange() {
            const data = fieldOptions.value.multiple
                // {foo => true, bar => false} => ['foo']
                ? Object.getOwnPropertyNames(model.value)
                    .filter(prop => model.value[prop]
                    && prop !== '__ob__'
                    && !(Array.isArray(model.value) && prop === 'length'))
                : model.value;
            log('FieldControlChoiceExpanded@change', props.field.name, data);
            emit('change', data);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.options?.choices, (choice) => {
                    return (_openBlock(), _createElementBlock("label", {
                        key: choice.value,
                        class: "form__radio-wrapper"
                    }, [
                        (fieldOptions.value.multiple)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "checkbox",
                                "onUpdate:modelValue": ($event) => ((model.value[choice.value]) = $event),
                                onChange: onChange,
                                onFocus: onFocus,
                                onBlur: onBlur,
                                disabled: fieldOptions.value.disabled || choice.disabled,
                                value: choice.value,
                                required: fieldOptions.value.required ?? undefined,
                                autocomplete: autocomplete.value,
                                id: __props.fieldId + '_' + choice.value
                            }, null, 40, _hoisted_2)), [
                                [_vModelCheckbox, model.value[choice.value]]
                            ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "radio",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                                onChange: onChange,
                                onFocus: onFocus,
                                onBlur: onBlur,
                                disabled: fieldOptions.value.disabled || choice.disabled,
                                value: choice.value,
                                required: fieldOptions.value.required ?? undefined,
                                autocomplete: autocomplete.value,
                                id: __props.fieldId + '_' + choice.value
                            }, null, 40, _hoisted_3)), [
                                [_vModelRadio, model.value]
                            ]),
                        _createTextVNode(" " + _toDisplayString(choice.label), 1)
                    ]));
                }), 128))
            ]));
        };
    }
});
